'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { useMutationErrorAlert } from '@/app/cc/_hooks/useMutationErrorAlert';
import calculateUsage from './calculateUsage';
export function useCalculateUsage() {
  const $ = _c(2);
  const handleMutationError = useMutationErrorAlert();
  let t0;
  if ($[0] !== handleMutationError) {
    t0 = {
      mutationFn: _temp,
      onError: error => {
        handleMutationError(error, {
          defaultMessage: "\uC548\uC2EC\uCF00\uC5B4 \uC774\uC6A9\uB8CC \uC870\uD68C\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.\n\uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.",
          rules: [{
            status: 422,
            fallback: "\uC22B\uC790\uB9CC \uC785\uB825 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\n\uB2E4\uC2DC \uC785\uB825\uD574\uC8FC\uC138\uC694",
            messageFrom: []
          }]
        });
      }
    };
    $[0] = handleMutationError;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
function _temp(t0) {
  const {
    price,
    dealType
  } = t0;
  return calculateUsage(price, dealType);
}